import { NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS } from '../../alerts/overview/alertsInventoryUrlParams';

class DimensionsService {
    getForPlots(plots = []) {
        return this._getUniqueDimensions(plots).map((dimension) => ({
            propertyName: dimension.key,
            propertyValue: dimension.value,
            url: this._getDataLinkUrl(dimension),
        }));
    }

    _getUniqueDimensions(plots) {
        const dimensions = plots
            .filter((plot) => !!plot.key)
            .flatMap((plot) => this._getPlotDimensions(plot));
        return _.uniqWith(dimensions, _.isEqual);
    }

    _getPlotDimensions(plot) {
        return Object.entries(plot.key)
            .map(([key, value]) => ({ key, value }))
            .filter((obj) => obj.key !== 'sf_metric');
    }

    _getDataLinkUrl({ key, value }) {
        if (key === 'sf_severity') {
            return `#/alerts?severity=${encodeURIComponent(
                value
            )}&${NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS}`;
        }
        return `#/alerts?customProperties=${encodeURIComponent(key)}:${encodeURIComponent(
            value
        )}&${NEW_ALERTS_INVENTORY_TIME_RANGE_PARAMS}`;
    }
}

export default DimensionsService;
